import { Stepper } from '@mantine/core';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { StepEmail } from './StepEmail';
import { StepEmailVerification } from './StepEmailVerification';
import { StepPassword } from './StepPassword';
import { StepFinalizeRegistration } from './StepFinalizeRegistration';
import { StepHealthData } from './StepHealthData';
import { UnsavedChangesGuard } from '../../../shared_components';
import { observer } from 'mobx-react-lite';
import { useUserDataStore } from '../../../shared_stores';

export interface StepProps {
  forward: () => void;
  back?: () => void;
}

export const RegistrationFlow = observer(() => {
  const [active, setActive] = useState(0);
  const navigate = useNavigate();
  const userDataStore = useUserDataStore();

  return (
    <Stepper active={active}>
      <Stepper.Step style={{ height: '100%' }}>
        <StepEmail
          forward={() => setActive(1)}
          back={() => window.history.back()}
          step={1}
          max={4}
        />
      </Stepper.Step>
      <Stepper.Step style={{ height: '100%' }}>
        <StepHealthData
          forward={() => setActive(2)}
          back={() => setActive(0)}
          step={2}
          max={4}
        />
      </Stepper.Step>
      <Stepper.Step style={{ height: '100%' }}>
        <StepPassword
          forward={() => setActive(3)}
          back={() => setActive(1)}
          step={3}
          max={4}
        />
      </Stepper.Step>
      <Stepper.Step style={{ height: '100%' }}>
        <StepEmailVerification
          forward={() => setActive(3)}
          back={() => setActive(2)}
          step={4}
          max={4}
        />
      </Stepper.Step>
      <Stepper.Step style={{ height: '100%' }}>
        <StepFinalizeRegistration
          forward={() => void navigate('/measurement/order')}
        />
      </Stepper.Step>
      <UnsavedChangesGuard when={userDataStore.storeDirty} />
    </Stepper>
  );
});
